import PropTypes from 'prop-types';
// import { Tween } from 'react-gsap';
import Section from '../Section.jsx';
import styles from './SectionVideo.module.scss';

function SectionVideo({ zIndex, debug, showTitlesOnSide, isLast, src }) {
  return (
    <Section zIndex={zIndex} debug={debug} isLast={isLast} showTitlesOnSide={showTitlesOnSide} className={styles.section}>
      {/* <Tween from={{ opacity: 1 }} to={{ opacity: 0 }}> */}
      <video
        src={`${process.env.PUBLIC_URL}/videos/${src}`}
        className={styles.video}
        playsInline
        muted
        loop
        autoPlay={process.env.NODE_ENV !== 'development'}
      />
      {/* </Tween> */}
    </Section>
  );
}

SectionVideo.propTypes = {
  zIndex: PropTypes.number,
  debug: PropTypes.bool,
  showTitlesOnSide: PropTypes.bool,
  isLast: PropTypes.bool,
  src: PropTypes.string.isRequired,
};

export default SectionVideo;
